const state = function () {
  return {
    loadingData: false,
    selectedTab: 'general',
    list: [],
    courseClassList: [],
    certificates: [],
    managers: [],
    selectedManagers: [],
    affiliates: [],
    selectedAffiliates: [],
    autoCompleteList: [],
    courseForm: {
      COURSE_ID: '',
      COURSE_NAME: '',
      STATES: [],
      COURSE_LENGTH_HOURS: null,
      COURSE_LENGTH_MINUTES: null,
      COURSE_LENGTH_SECONDS: null,
      COURSE_NOTES: '',
      DISABLE_APPROVAL_PROCESS: false,
      DISABLE_PAYMENTS: false,
      ENABLE_NY_REPORTS: false
    },
    coursePagination: {
      rowsNumber: 0,
      rowsPerPage: 10,
      page: 1,
      descending: true,
      sortBy: ''
    },
    courseManagerPagination: {
      rowsNumber: 0,
      rowsPerPage: 10,
      page: 1,
      descending: true,
      sortBy: 'DATE_CREATED'
    },
    courseAffiliatePagination: {
      rowsNumber: 0,
      rowsPerPage: 10,
      page: 1,
      descending: true,
      sortBy: 'DATE_CREATED'
    }
  }
}

export default {
  ...state()
}

export const initialState = state()
